// ==============================|| HOOKS - CONFIG  ||============================== //

import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {MenuOrientation, ThemeDirection, ThemeMode} from '../../configs/themeConfig';
import {
    configurationSelector,
    onChangeContainer,
    onChangeContrast,
    onChangeDirection,
    onChangeFontFamily,
    onChangeLocalization,
    onChangeMenuCaption,
    onChangeMenuOrientation,
    onChangeMiniDrawer,
    onChangeMode,
    onChangePresetColor,
} from '../../store/Theme';
import {FontFamily, I18n, PresetColor} from '../../types';

export const useConfigurationInRedux = () => {
    const dispatch = useDispatch();
    const {
        container: containerInRedux,
        fontFamily: fontFamilyInRedux,
        i18n: i18nInRedux,
        menuCaption: menuCaptionInRedux,
        menuOrientation: menuOrientationInRedux,
        miniDrawer: miniDrawerInRedux,
        mode: modeInRedux,
        presetColor: presetColorInRedux,
        themeContrast: themeContrastInRedux,
        themeDirection: themeDirectionInRedux,
    } = useSelector(configurationSelector);

    const container = useMemo(() => {
        return containerInRedux;
    }, [containerInRedux]);

    const fontFamily = useMemo(() => {
        return fontFamilyInRedux;
    }, [fontFamilyInRedux]);

    const i18n = useMemo(() => {
        return i18nInRedux;
    }, [i18nInRedux]);

    const menuCaption = useMemo(() => {
        return menuCaptionInRedux;
    }, [menuCaptionInRedux]);

    const menuOrientation = useMemo(() => {
        return menuOrientationInRedux;
    }, [menuOrientationInRedux]);

    const miniDrawer = useMemo(() => {
        return miniDrawerInRedux;
    }, [miniDrawerInRedux]);

    const mode = useMemo(() => {
        return modeInRedux;
    }, [modeInRedux]);

    const presetColor = useMemo(() => {
        return presetColorInRedux;
    }, [presetColorInRedux]);

    const themeContrast = useMemo(() => {
        return themeContrastInRedux;
    }, [themeContrastInRedux]);

    const themeDirection = useMemo(() => {
        return themeDirectionInRedux;
    }, [themeDirectionInRedux]);

    const setContainerInRedux = useCallback(
        (value: boolean) => {
            dispatch(onChangeContainer(value));
        },
        [dispatch],
    );

    const setFontFamilyInRedux = useCallback(
        (value: FontFamily) => {
            dispatch(onChangeFontFamily(value));
        },
        [dispatch],
    );

    const setI18nInRedux = useCallback(
        (value: I18n) => {
            dispatch(onChangeLocalization(value));
        },
        [dispatch],
    );

    const setMenuCaptionInRedux = useCallback(
        (value: boolean) => {
            dispatch(onChangeMenuCaption(value));
        },
        [dispatch],
    );

    const setMenuOrientationInRedux = useCallback(
        (value: MenuOrientation) => {
            dispatch(onChangeMenuOrientation(value));
        },
        [dispatch],
    );

    const setMiniDrawerInRedux = useCallback(
        (value: boolean) => {
            dispatch(onChangeMiniDrawer(value));
        },
        [dispatch],
    );

    const setModeInRedux = useCallback(
        (value: ThemeMode) => {
            dispatch(onChangeMode(value));
        },
        [dispatch],
    );

    const setPresetColorInRedux = useCallback(
        (value: PresetColor) => {
            dispatch(onChangePresetColor(value));
        },
        [dispatch],
    );

    const setThemeContrastInRedux = useCallback(
        (value: boolean) => {
            dispatch(onChangeContrast(value));
        },
        [dispatch],
    );

    const setThemeDirectionInRedux = useCallback(
        (value: ThemeDirection) => {
            dispatch(onChangeDirection(value));
        },
        [dispatch],
    );

    return {
        container,
        fontFamily,
        i18n,
        menuCaption,
        menuOrientation,
        miniDrawer,
        mode,
        presetColor,
        themeContrast,
        themeDirection,
        setContainerInRedux,
        setFontFamilyInRedux,
        setI18nInRedux,
        setMenuCaptionInRedux,
        setMenuOrientationInRedux,
        setMiniDrawerInRedux,
        setModeInRedux,
        setPresetColorInRedux,
        setThemeContrastInRedux,
        setThemeDirectionInRedux,
    };
};

export default useConfigurationInRedux;
